// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

export default class TimelineByWorkflowTinySlider extends WebComponent {
	didMount() {


		var slider = tns({
			container: '.workflow__list',
			controlsContainer: '.workflow__controls',
			items: 2,
			fixedWidth: 160,
			nav: false,
			slideBy: 'page',
			autoplay: false,
			rewind: true,
			// responsive: {
			// 	500: {
			// 		items: 2
			// 	},
			// 	700: {
			// 		items: 3
			// 	},
			// 	900: {
			// 		items: 4
			// 	},
			// 	1100: {
			// 		items: 5
			// 	},
			// 	1200: {
			// 		items: 5
			// 	},
			// 	1620: {
			// 		items: 7
			// 	}
			// },
			mouseDrag: true
		});
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/TimelineByWorkflowTinySlider.js